import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./Components/UI/Root";
import Home from "./Components/Pages/Home/Home";
import Contacts from "./Components/Pages/Contatti/Contacts";
import News from "./Components/Pages/News/News";
import NewsInner from "./Components/Pages/News/NewsInner";
import Brand from "./Components/Pages/Brand/brand";
import BrandInner from "./Components/Pages/Brand/BrandInner";
import ContractInner from "./Components/Pages/Contract/contractinner";
import Group from "./Components/Pages/Group/group";
import Contract from "./Components/Pages/Contract/contract";
import Cookies from "./Components/Pages/Cookies/cookies";
import Policy from "./Components/Pages/Policy/policy";
import NotFoundComponent from "./Components/NotFound";
function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      // errorElement: <ErrorPage />,
      id: "root",
      // loader: RootData,
      children: [
        {
          index: true,
          element: <Group />,
        },

        {
          element: <News />,
          path: "/news",
        },
        {
          element: <NewsInner />,
          path: "/news/:slug",
        },
        {
          element: <Brand />,
          path: "/brand",
        },
        {
          element: <BrandInner />,
          path: "/brand/:slug",
        },
        {
          element: <Group />,
          path: "/group",
        },
        {
          element: <Contract />,
          path: "/contract",
        },
        {
          element: <ContractInner />,
          path: "/contract/:slug",
        },
        {
          element: <Cookies />,
          path: "/cookies",
        },
        {
          element: <Policy />,
          path: "/policy",
        },
        {
          element: <Contacts />,
          path: "/contatti",
        },
        {
          path: "*",
          element: <NotFoundComponent />, // Renders the NotFoundComponent on 404
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
